import Breadcrumbs from "components/Common/Breadcrumb"
import React, { useEffect, useRef, useState } from "react"
import { Button, Card, CardBody, CardTitle } from "reactstrap"
import { Formik, Form } from "formik"
import Select from "react-select"
import { useSelector } from "react-redux"
import { getAllBranchs } from "store/actions/usersAction"
import { useDispatch } from "react-redux"
import Switch from "components/Shared/Switch"
import { showAlert } from "store/reducers/alertReducer"
import QRCode from "qrcode.react"
import html2canvas from "html2canvas"
import { jsPDF } from "jspdf"
import StarRatings from "react-star-ratings"
import { generateQrCodeSchema } from "components/Common/validation"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"
import { getGlobalSettingByType } from "store/actions/globalSettingAction"

const initialValues = {
  branchId: "",
  type: "",
}
const GenerateQRCode = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Generate QR Code | Sign Burger")

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const qrCodeRef = useRef(null)

  const [formValues, setFormValues] = useState(initialValues)
  const [qrCodeLink, setQrCodeLink] = useState("")
  const [qrType, setQrType] = useState(null)
  const [branchName, setBranchName] = useState(null)
  const [isShowBranchName, setIsShowBranchName] = useState(false)
  const { branchsList } = useSelector(state => state.Users)
  const { globalSettings } = useSelector(state => state.GlobalSettings)

  const { userRole, accountType } = useSelector(state => state.Login)
  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    edit: null,
  })

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      22,
      "qr_code_1",
      accountType
    )

    const isPermissionEdit = isPermissionEnabled(
      userRole,
      22,
      "qr_code_3",
      accountType
    )
    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
      edit: isPermissionEdit,
    })
  }, [userRole])

  useEffect(() => {
    fetchAllBranchs()
    fetchGlobalSettings()
  }, [])

  const fetchAllBranchs = () => {
    dispatch(getAllBranchs())
  }

  const fetchGlobalSettings = () => {
    dispatch(getGlobalSettingByType({ type: "globalSettings" }))
  }

  const ratingType = [
    { label: t("Rating"), value: "rating" },
    { label: t("Order"), value: "order" },
  ]

  const handleOnSubmit = async (values, { resetForm }) => {
    const { branchId, type } = values
    const updatedBranchId = branchId.value
    const updatedType = type.value
    const settings = globalSettings?.globalSettings || {}

    // Order QR: direct link from system settings (no Firebase)
    if (updatedType === "order") {
      const baseUrl = (settings.qrCodeBaseUrl || "").replace(/\/$/, "")

      if (!baseUrl) {
        dispatch(
          showAlert({
            text: t("QR Code Base URL is not configured"),
            type: "error",
          })
        )
        return
      }

      const orderLink = `${baseUrl}/${updatedBranchId}`
      setBranchName(branchId.label)
      setQrCodeLink(orderLink)
      setQrType(updatedType)
      return
    }

    // Rating QR: direct link into QR ordering public rating route
    // Example: http://localhost:3000/sign-qr-ordering/rating/{branchId}
    if (updatedType === "rating") {
      const baseUrl = (
        settings.ratingQrBaseUrl || "http://localhost:3000/sign-qr-ordering"
      ).replace(/\/$/, "")

      const ratingLink = `${baseUrl}/rating/${updatedBranchId}`
      setBranchName(branchId.label)
      setQrCodeLink(ratingLink)
      setQrType(updatedType)
      return
    }

    dispatch(
      showAlert({
        text: "Something went wrong. Please try again.",
        type: "error",
      })
    )
  }

  const exportToPDF = () => {
    if (qrCodeRef.current) {
      html2canvas(qrCodeRef.current, { scale: 5 }).then(canvas => {
        const imgData = canvas.toDataURL("image/png")
        const pdf = new jsPDF()
        const imgProps = pdf.getImageProperties(imgData)
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight)
        pdf.save(`${t("QR-Code")}.pdf`)
      })
    }
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <div className="row">
          <div className="col-lg-6">
            <Card className="full_height_card">
              <CardBody>
                <CardTitle>{t("Generate QR Code")}</CardTitle>
                <Formik
                  initialValues={formValues}
                  onSubmit={handleOnSubmit}
                  validationSchema={generateQrCodeSchema}
                >
                  {({
                    values,
                    setFieldValue,
                    errors,
                    touched,
                    isSubmitting,
                  }) => (
                    <Form>
                      <div className="row ">
                        <div className="col-lg-12">
                          <div className="mt-3">
                            <label htmlFor="branchId">
                              {t("Select Branch")}{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <Select
                              value={values.locations}
                              onChange={item => {
                                setFieldValue("branchId", item)
                              }}
                              options={branchsList?.map(item => ({
                                label:
                                  language === "sa" ? item.nameAr : item.name,
                                value: item._id,
                              }))}
                              className={`select2-selection ${
                                touched.branchId && errors.branchId
                                  ? "danger_color_border"
                                  : ""
                              } `}
                              placeholder={t("Select Branch")}
                            />
                            <TextError name="branchId" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mt-3">
                            <label htmlFor="type">{t("Select QR Type")}{" "}
                            <span className="text-danger">*</span>
                            </label>
                            <Select
                              value={values.locations}
                              onChange={item => {
                                setFieldValue("type", item)
                              }}
                              options={ratingType?.map(item => ({
                                label: item.label,
                                value: item.value,
                              }))}
                              className={`select2-selection ${
                                touched.type && errors.type
                                  ? "danger_color_border"
                                  : ""
                              } `}
                              placeholder={t("Select QR Type")}
                            />
                            <TextError name="type" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mt-3">
                            <label htmlFor="isShowBranchName">
                              {t(
                                "Do You Want To Print Branch Name Underneath The QR Code"
                              )}
                            </label>
                            <Switch
                              isChecked={isShowBranchName}
                              onClickHandler={() =>
                                setIsShowBranchName(!isShowBranchName)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-12">
                          {usersPermissions.edit && (
                            <Button
                              type="submit"
                              color="success"
                              className="d-block ms-auto"
                              disabled={isSubmitting}
                            >
                              {t("Generate QR Code")}
                            </Button>
                          )}
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </div>
          <div className="col-lg-6">
            <Card className="full_height_card qr_code_view">
              <CardBody className="g_center">
                {qrCodeLink ? (
                  <div>
                    <div ref={qrCodeRef} className="px-4 pb-2">
                      <div className="qr_code">
                        <QRCode
                          value={qrCodeLink}
                          size={250}
                          level="H"
                          includeMargin={true}
                          renderAs="svg"
                        />
                      </div>

                      {qrType !== "order" && (
                        <div className="mb-3 g_center">
                          <StarRatings
                            rating={5}
                            starRatedColor="#F1B44C"
                            starEmptyColor="#74788d"
                            numberOfStars={5}
                            name="rating"
                            starDimension="24px"
                            starSpacing="3px"
                          />
                        </div>
                      )}

                      {isShowBranchName && (
                        <p className="text-center fw-bold fs-5 text-black">
                          {branchName}
                        </p>
                      )}
                      <h3 className="text-black text-center fz-bold mt-2">
                        {t("Sign Burger")}
                      </h3>
                    </div>
                    <div className="d-flex">
                      <Button
                        color="primary"
                        className="mx-auto d-block mt-3"
                        onClick={exportToPDF}
                        disabled={!qrCodeLink}
                      >
                        {t("Download To PDF")}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="px-4 pb-2">
                    {/* <h2 className="text-center text-black">
                      Happy With Our Service?
                    </h2>
                    <p className=" text-center mt-2">
                      Help spread the word. Review us on App
                    </p> */}
                    <div className="qr_code">
                      <QRCode
                        value="https://example.com"
                        size={250}
                        level="H"
                        includeMargin={true}
                        renderAs="svg"
                      />
                    </div>
                    <div className="mb-3 g_center">
                      <StarRatings
                        rating={5}
                        starRatedColor="#F1B44C"
                        starEmptyColor="#74788d"
                        numberOfStars={5}
                        name="rating"
                        starDimension="24px"
                        starSpacing="3px"
                      />
                    </div>
                    <h3 className="text-black text-center fz-bold mt-2">
                      {t("Sign Burger")}
                    </h3>
                  </div>
                )}
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GenerateQRCode
